import React from 'react';
import PropTypes from 'prop-types';

import ProfileDropdown from '../DropdownMenu/ProfileDropdown';
import HeaderBusinessSelect from './HeaderBusinessSelect';

import { WELLNESS } from '../../assets/Domains';

import Logo from '../../assets/images/logo@2x.png';
import Profile from './img/profile.png'
import arrow from './img/triangle@2x.png';
import utils from '../../lib/utils';

import './index.scss';

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      profileDropdownVisibility: false,
      animatePopup: false,
    };

    this.onProfileDropdownClick = this.onProfileDropdownClick.bind(this);
    this.onDropdownVisibilityChange = this.onDropdownVisibilityChange.bind(
      this,
    );
  }

  onProfileDropdownClick(event) {
    event.preventDefault();

    if (!this.state.profileDropdownVisibility) {
      event.stopPropagation();
    }

    this.setState({
      profileDropdownVisibility: true,
    });
  }

  onDropdownVisibilityChange(visibility) {
    this.setState({
      profileDropdownVisibility: visibility,
    });
  }
  onHeaderPopupClose = () => {
    this.setState({ animatePopup: true });
    setTimeout(() => {
      this.props.closeAdvPopup(); // Remove from DOM after animation
    }, 500); 
  }
  render() {
    const profileDropdownProps = {
      onClick: this.onProfileDropdownClick,
    };

    const name = [
      this.props.business.info.FIRST_NAME || '',
      this.props.business.info.LAST_NAME || '',
    ].join(' ');
    const { toggleSideNav, headerPopupVisibility, auth } = this.props;
    const business_name = utils.getCookie('studio_name');
    const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
    const features = utils.getCookie('features');
    const studioName = this.props.business?.studioName || business_name || auth?.studio_name;
    return (
      <div className='header__container'>
        {/* {features && !features.includes('APPOINTMENT_REMINDER_HIDDEN') && headerPopupVisibility && 
          <div className={`header__popup ${this.state.animatePopup ? "closing" : " "}`}>
              <div className='header__description'>
                <strong>NEW!{" "}</strong>Get the{" "}
              <a className='messenger-action' href={window.Config.AI_REMINDER.GET_ADD_ON_LINK} target='_blank'>AI reminders</a>
              {" "}add-on to streamline booking process and reduce no-shows.{" "}
                <a className='messenger-action-upgrade' href="mailto:support@truelark.com">Get in touch to upgrade</a>
              </div>
              <i className="material-icons" onClick={this.onHeaderPopupClose}>close</i>
            </div>
          } */}
        {/* <NotificationBar /> */}
        <div className="header">
          <div className="header_hamberger" onClick={toggleSideNav}>
            <i className="material-icons">menu</i>
          </div>
          <div className="header__logo">
            <div className="header__logo__image">
              <img src={Logo} alt="logo" width={150} />
            </div>
          </div>
          
          <div className="header__content">
            {csroles.includes(auth.role) && <HeaderBusinessSelect studioName={studioName} />}
            <div className="header__content__profile" {...profileDropdownProps}>
            <div className="logo"><img src={Profile}/></div>
              <span className="user-profile">{name}</span>
              <img className="user-profile-arrow" src={arrow} alt="dropdown" width={9} />
              <ProfileDropdown
                visibility={this.state.profileDropdownVisibility}
                position="tr"
                onVisibilityChange={this.onDropdownVisibilityChange}
                profileInfo={this.props.business.info}
                billingInfo={this.props.billing.info}
                currentDomain={this.props.currentDomain}
                userRole={this.props.business.clientUser}
              
              />
            </div>
            <div className="header__content__notification hide">
              <i className="material-icons">notifications</i>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Header.defaultProps = {
  business: {
    info: {
      EMAIL: '',
    },
  },
  currentDomain: WELLNESS,
};

Header.propTypes = {
  business: PropTypes.shape({
    info: PropTypes.object,
  }),
  billing: PropTypes.shape({
    info: PropTypes.object,
  }).isRequired,
  currentDomain: PropTypes.string,
  toggleSideNav: PropTypes.func.isRequired,
};
